import jQuery from "jquery";
import {ZIDX, ZIDXPage} from "../../standalone/standaloneLibrary.js";

const $ = jQuery.noConflict();
export class ZIDXAccountCMAReportsSearch implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountCMAReportsSearchContainer";
    }
    render(){
        let self=this;
        // console.log("cma-reports/search");
        $(".refineSelectListingSearch", this.zidx.peakidxShadowRoot).on("click", function(this:HTMLAnchorElement){
            let cma_id=$(this).attr("data-cma-id");
            var modalContent1='<iframe src="/account/cma-reports/refine-search?cma_id='+cma_id+'"  style="margin:0px;border:none; overflow:auto;" seamless="seamless" width="100%" height="95%"><\/iframe>';
            // var modalContent1="Model content";
            // @ts-ignore
            self.zidx.modalWindow.showModal(modalContent1,{'width':self.zidx.windowSize.width-100,'height':self.zidx.windowSize.height-100});
        });
        $(".listingIds", this.zidx.peakidxShadowRoot).on("click", function(this, e:JQuery.ClickEvent){
            let count=0;
            $(".listingIds", self.zidx.peakidxShadowRoot).each(function(this){
                if((this as HTMLInputElement).checked) {
                    count++;
                }
            });
            if(count>5) {
                (e.currentTarget as HTMLInputElement).checked = false;
                alert("You can only select up to 5 listings at a time.");
            }
        });
        $(".addressSpan1", this.zidx.peakidxShadowRoot).on("click", function(this, e:JQuery.ClickEvent){
            let listingId=$(this).attr("data-id");
            var modalContent1='<iframe src="/account/cma-reports/listing?listing_id='+listingId+'"  style="margin:0px;border:none; overflow:auto;" seamless="seamless" width="100%" height="95%"><\/iframe>';
            // var modalContent1="Model content";
            // @ts-ignore
            self.zidx.modalWindow.showModal(modalContent1,{'width':self.zidx.windowSize.width-100,'height':self.zidx.windowSize.height-100});
        });
        const formElement=self.zidx.peakidxShadowRoot.getElementById("selectedListingsForm");
        formElement?.setAttribute("data-event-bound", "1");
        formElement?.addEventListener("submit", function (e:Event) {
            e.preventDefault();
            let postObj=self.zidx.getFormDataByFormId("selectedListingsForm");
            // if (postObj.listingIds!="") {
                let obj = {
                    id: "ajaxSaveSelectedListings",
                    method: "post",
                    postObj: postObj,
                    ignoreOldRequests: true,
                    callback: function(r:string){
                        let rs=JSON.parse(r);
                        if(rs.success) {
                            if(rs.redirectURL){
                                window.location.href = rs.redirectURL;
                            }
                        }else{
                            alert(rs.errorMessage);
                        }
                    },
                    errorCallback: function(r:string){
                        alert("There was a temporary network problem, please try again later");
                    },
                    url: "/account/cma-reports/search/save"
                };
                self.zidx.ajaxRequest(obj);
            // } else {
            //     alert("Please select at least one listing before saving.");
            // }
        });
    }
}